import React from "react";
import IntervalSet from "../../../../models/communications/IntervalSet";
import Interval from "../../../../models/communications/Interval";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// import PathwayIcon from "./PathwayIcon";
import Stack from "@mui/material/Stack";
import useHttp from "../../../../hooks/useHttp";
import ExistingIntervalPreview from "./ExistingIntervalPreview";
import Divider from "@mui/material/Divider";

interface ExistingIntervalSetProps {
  id: string | number;
  intervalSet: IntervalSet;
  intervalsForThisSet: Array<Interval>;
}

const ExistingIntervalSetPreview = (props: ExistingIntervalSetProps) => {
  //   const [intervalsForThisSet, setIntervalsForThisSet] = useState<
  //     Array<Interval>
  //   >([]);

  const { sendRequest: fetchData } = useHttp();

  //   useEffect(() => {
  //     let route = "/interval";
  //     const url: string =
  //       process.env.REACT_APP_API_URL + route + "?interval_set_id=eq." + props.intervalSet.id;
  //     const requestSettings = {
  //       url: url,
  //       method: "GET",
  //       headers: {
  //         Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
  //         "Content-Type": "application/json",
  //       },
  //     };
  //     fetchData(requestSettings, (data: Array<Interval>) => {
  //       setIntervalsForThisSet(data);
  //     });
  //   }, [fetchData]);

  return (
    <div>
      <Box
        sx={{
          width: "99%",
          flexGrow: 1,
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "15px",
          border: "1pt solid #ebeded",
          borderRadius: "10px 10px",
          paddingBottom: "20px",
        }}
      >
        <h2 style={{ paddingTop: "10px", paddingLeft: "20px" }}>
          {props.intervalSet.name} {"(ID: " + props.intervalSet.id + ")"}
        </h2>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            {/* if needed */}
          </Grid>
          <Grid item xs={6}>
            {/* if needed */}
          </Grid>
        </Grid>
        <Divider />

        <div style={{ padding: "10px" }}>
          <h4 style={{ padding: "10px" }}>Associated Intervals:</h4>

          {props.intervalsForThisSet.length > 0 && (
            <Stack>
              {props.intervalsForThisSet.map((interval: Interval) => {
                return (
                  <ExistingIntervalPreview
                    key={interval.id}
                    fromIntervalSet={true}
                    interval={interval}
                  />
                );
              })}
            </Stack>
          )}
          {props.intervalsForThisSet.length < 1 && (
            <span
              style={{ color: "red", paddingLeft: "30px", fontSize: "14pt" }}
            >
              {" "}
              No Intervals. Edit Interval Set to add Intervals and Interactions
              to it.{" "}
            </span>
          )}
        </div>
      </Box>
    </div>
  );
};

export default ExistingIntervalSetPreview;
